import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=de9873d4"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&id=de9873d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports